// Rodagem: a experiência do jogador. No fim de partida, o que a partida rendeu (com o detalhe dos lances, a mesa com
// bot, a mesa cheia e a Rodada quente) e a barra do nível; no perfil, o nível; na mesa, o nível ao lado do rosto e o
// número que sobe na hora do lance. Tudo calculado no servidor (packages/gamificacao); aqui só mostra.
import { useEffect } from 'react';
import type { LinhaDeRodagem, NivelRodagem, RodagemNoFim } from '@truco6/gamificacao';
import { medirUmaVez } from '../comum/medicao.ts';

const NOME_DO_LANCE: Record<string, string> = {
  zap_rodada: 'Zap que ganha a rodada', truco_ganho: 'Truco aceito e ganho', blefe: 'Blefe Vencedor',
  peito_de_aco: 'Peito de Aço', mao_de_ferro: 'Mão de Ferro Vencida', virada: 'Virada',
};
const NOME_DA_LINHA: Record<Exclude<LinhaDeRodagem['motivo'], 'lance'>, string> = {
  partida: 'Partida terminada', vitoria: 'Vitória', com_bot: 'Mesa com bot', mesa_cheia: 'Mesa cheia de amigos',
  rodada_quente: 'Rodada quente', sala_criada: 'Sala criada', mesa_cheia_dono: 'Dono da mesa cheia', divisao_subiu: 'Subiu de divisão', badge: 'Badge novo',
  ofensiva_dia: 'Dia de ofensiva', ofensiva_marco: 'Marco da ofensiva', missao: 'Missão concluída', passe: 'Passe da Temporada',
};
function nomeDaLinha(l: LinhaDeRodagem, bonus: number): string {
  if (l.motivo === 'lance') return nomeDoLance(l.lance);
  if (l.motivo === 'rodada_quente') return `Rodada quente +${bonus}%`;
  if (l.motivo === 'ofensiva_marco') return `Ofensiva de ${l.dias} dias`;
  return NOME_DA_LINHA[l.motivo];
}
export const nomeDoLance = (l: string) => NOME_DO_LANCE[l] ?? 'Lance';
const comSinal = (n: number) => (n > 0 ? `+${n}` : n < 0 ? `−${-n}` : '0');
const milhar = (n: number) => n.toLocaleString('pt-BR');

export function BarraDoNivel({ n, rotulo = true }: { n: NivelRodagem; rotulo?: boolean }) {
  return (
    <div className="nivel-barra">
      {rotulo && <p><b>Nível {n.nivel}</b><span>{milhar(n.noNivel)}/{milhar(n.paraOProximo)}</span></p>}
      <span className="trilho-nivel" role="progressbar" aria-label={`Nível ${n.nivel}: ${n.noNivel} de ${n.paraOProximo} de Rodagem`}
        aria-valuemin={0} aria-valuemax={n.paraOProximo} aria-valuenow={n.noNivel}>
        <i style={{ width: `${Math.round((n.noNivel / n.paraOProximo) * 100)}%` }} />
      </span>
    </div>
  );
}

// Fim de partida: o total, cada linha e a barra do nível. GA4 nivel_subiu uma vez por partida.
export function RodagemDaPartida({ r, partida }: { r: RodagemNoFim; partida: string }) {
  const subiu = r.nivel.nivel > r.nivel.antes;
  useEffect(() => { if (subiu) medirUmaVez('nivel:' + partida, 'nivel_subiu', { nivel: r.nivel.nivel }); }, [subiu, partida]);
  return (
    <section className="cartao rodagem-fim" aria-label="Rodagem da partida">
      <div className="rodagem-fim-cab">
        <b className="rotulo">RODAGEM</b>
        <strong>{comSinal(r.total)}</strong>
      </div>
      <ul>
        {r.linhas.map((l, i) => (
          <li key={i} className={l.rodagem < 0 ? 'neg' : undefined}>
            <span>{nomeDaLinha(l, r.quente.bonus)}</span>
            <b>{comSinal(l.rodagem)}</b>
          </li>
        ))}
      </ul>
      {subiu && <p className="subiu">Subiu para o nível {r.nivel.nivel}!</p>}
      <BarraDoNivel n={r.nivel} />
    </section>
  );
}

// Nível no perfil.
export function NivelDoPerfil({ n }: { n: NivelRodagem }) {
  return (
    <section className="cartao nivel-perfil" aria-label="Seu nível">
      <div className="nivel-perfil-cab">
        <span className="selo-nivel" aria-hidden="true">{n.nivel}</span>
        <p><b>Nível {n.nivel}</b><small>{milhar(n.total)} de Rodagem · faltam {milhar(n.paraOProximo - n.noNivel)} para o {n.nivel + 1}</small></p>
      </div>
      <BarraDoNivel n={n} rotulo={false} />
    </section>
  );
}
